import React, { useContext, useEffect } from 'react';
import { selectIsLoggedIn, selectUserRole, selectUsername } from 'src/redux/auth/auth.selectors';

import { CanaryNetworkServiceContext } from '../CanaryNetworkServiceProvider/CanaryNetworkServiceProvider';
import { getFrontendUserRoleName } from 'src/utils/getFrontendUserRoleName';
import { matchPath } from 'react-router';
import { routesConfig } from '../../routes/routes.config';
import { selectSCMFlow } from 'src/redux/scm/scm.selectors';
import { setAvailableUserRoles } from 'src/redux/application/application.slice';
import { useAppDispatch } from 'src/redux/store';
import { useAppLocation } from '../../hooks/useAppLocation';
import { useAvailableUserRolesLazyQuery } from 'src/graphql';
import { useSelector } from 'react-redux';

type TPageEffectsContainer = {
  children: React.ReactNode;
};

const PageEffectsContainer: React.FC<TPageEffectsContainer> = ({ children }) => {
  const dispatch = useAppDispatch();
  const isSCMFlow = useSelector(selectSCMFlow);

  const CanaryNetworkContext = useContext(CanaryNetworkServiceContext);
  const userName = useSelector(selectUsername);
  const userRole = useSelector(selectUserRole);
  const isLoggedIn = useSelector(selectIsLoggedIn);
  const location = useAppLocation();

  const [fetchAvailableUserRoles] = useAvailableUserRolesLazyQuery({
    fetchPolicy: 'no-cache',
    onCompleted: ({ availableUserRoles }) => {
      const roles = availableUserRoles!.userRoles!.map((item) => ({
        roleName: getFrontendUserRoleName(item!.roleName!),
        value: item!.value!,
      }));

      dispatch(setAvailableUserRoles(roles || []));
    },
  });

  useEffect(() => {
    if (!isLoggedIn) return;
    fetchAvailableUserRoles();
  }, [fetchAvailableUserRoles, isLoggedIn]);

  useEffect(() => {
    if (userName && !isSCMFlow) {
      CanaryNetworkContext.fetcAllUserToAdminRequests(userName);
    }
  }, [CanaryNetworkContext, userName, isSCMFlow]);

  useEffect(() => {
    if (
      !!matchPath(location.pathname, {
        path: routesConfig.singularityMap(),
      }) &&
      !isSCMFlow
    ) {
      CanaryNetworkContext.fetchGlobalListUserToAdminRequests();
    }
  }, [CanaryNetworkContext, location.pathname, userRole, isSCMFlow]);

  return <>{children}</>;
};
export default PageEffectsContainer;
